import React from 'react';

export default function Program() {
  const days = [
    {
      id: 1,
      title: '1 Mayıs 2026 Cuma',
      events: [
        { time: '07:30', name: 'Karşılama', location: '' },
        { time: '14:30 - 16:30', name: 'Havuzlar Altında 2430 Fersah Parti', location: '' },
        { time: '15:30 - 17:30', name: 'Başkanlar Bayrak Töreni Prova', location: 'Oditoryum' },
        { time: '19:30 - 00:00', name: 'Bayrak Töreni', location: 'Oditoryum' },
        { time: '00:00 - 03:00', name: 'Neverland Partisi', location: '' },
      ]
    },
    {
      id: 2,
      title: '2 Mayıs 2026 Cumartesi',
      events: [
        { time: '07:30', name: 'Karşılama', location: '' },
        { time: '12:30 - 14:30', name: 'Kahramanlar Arenası', location: '' },
        { time: '14:30 - 16:30', name: 'La Fontaine\'den Partiler', location: '' },
        { time: '19:30 - 23:30', name: 'Gala Yemeği', location: 'Oditoryum' },
        { time: '23:30 - 01:00', name: 'DJ Performansı - Erdem Kınay', location: '' },
      ]
    },
    {
      id: 3,
      title: '3 Mayıs 2026 Pazar',
      events: [
        { time: '12:00', name: 'Checkout', location: '' }
      ]
    }
  ];

  return (
    <section className="py-5" style={{ minHeight: '80vh', display: 'flex', alignItems: 'center' }}>
      <div className="container">
        <h1 className="text-center mb-5" style={{ marginTop: '50px', color: '#fff' }}>Konferans Program Akışı</h1>
        <div className="row justify-content-center">
          {days.map((day) => (
            <div className="col-lg-4 col-md-6 mb-4" key={day.id}>
              <div
                className="card h-100"
                style={{
                  backgroundColor: 'rgba(34, 13, 28, 0.65)', /* Dark theme base from images */
                  borderColor: 'rgba(219, 158, 55, 0.3)', /* Gold border */
                  borderRadius: '24px',
                  backdropFilter: 'blur(15px)',
                  border: '1px solid rgba(219, 158, 55, 0.4)',
                  boxShadow: '0 8px 32px 0 rgba(0, 0, 0, 0.5)',
                  padding: '2rem 1.5rem',
                  transition: 'transform 0.3s ease',
                  cursor: 'default'
                }}
                onMouseOver={(e) => e.currentTarget.style.transform = 'translateY(-10px)'}
                onMouseOut={(e) => e.currentTarget.style.transform = 'translateY(0)'}
              >
                <div className="text-center mb-4 pb-3" style={{ borderBottom: '1px solid rgba(219, 158, 55, 0.2)' }}>
                  <h4 style={{ color: '#db9e37', fontWeight: 'bold', margin: 0 }}>{day.title.split(' ').slice(0, 3).join(' ')}</h4>
                  <h5 style={{ color: 'rgba(255,255,255,0.9)', marginTop: '8px', letterSpacing: '2px' }}>{day.title.split(' ')[3]}</h5>
                </div>
                
                <div className="timeline-container d-flex flex-column gap-4">
                  {day.events.map((event, index) => (
                    <div key={index} className="d-flex align-items-start gap-3">
                      <div 
                        className="flex-shrink-0 text-end" 
                        style={{ width: '100px', color: '#db9e37', fontWeight: 'bold', fontSize: '1.05rem', marginTop: '2px' }}
                      >
                        {event.time}
                      </div>
                      <div 
                        className="flex-shrink-0" 
                        style={{ 
                          width: '12px', 
                          height: '12px', 
                          borderRadius: '50%', 
                          backgroundColor: '#db9e37', 
                          marginTop: '8px',
                          boxShadow: '0 0 10px rgba(219, 158, 55, 0.6)'
                        }}
                      ></div>
                      <div className="flex-grow-1">
                        <h6 style={{ fontFamily: 'system-ui, -apple-system, "Segoe UI", Roboto, Helvetica, Arial, sans-serif', color: '#ffffff', margin: 0, lineHeight: '1.4', fontSize: '1.15rem', fontWeight: '500' }}>{event.name}</h6>
                        {event.location && (
                          <small style={{ fontFamily: 'system-ui, -apple-system, "Segoe UI", Roboto, Helvetica, Arial, sans-serif', color: 'rgba(255,255,255,0.7)', display: 'block', marginTop: '4px' }}>
                            <i className="bi bi-geo-alt-fill me-1"></i>
                            {event.location}
                          </small>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
